import colors from '../constants/colors';

export const getStatusColors = (status) => {
    const color = colors[status.toLowerCase()];
    const lightColor = colors[`${status.toLowerCase()}Light`];
    return [color, lightColor];
};